import { logger } from '../services/logger.ts';
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Missing Supabase environment variables');
}

// Create Supabase client with proper configuration
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    storageKey: 'wayja_auth_token',
    storage: window.localStorage,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce', // Note: If you have issues with password reset, update your email template to use token_hash
    debug: process.env.NODE_ENV === 'development'
  },
  global: {
    headers: {
      'apikey': supabaseKey
    }
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
});

// Add session refresh handler
supabase.auth.onAuthStateChange((event) => {
  if (event === 'TOKEN_REFRESHED') {
    logger.info('Auth token refreshed successfully');
  } else if (event === 'SIGNED_OUT') {
    logger.info('User signed out, cleaning up session');
  }
});

// Add health check function
export const checkSupabaseConnection = async () => {
  try {
    const { error } = await supabase
      .from('markets')
      .select('id')
      .limit(1)
      .throwOnError();

    if (error) throw error;
    return true;
  } catch (error) {
    logger.error('Supabase connection error:', error);
    return false;
  }
};